import React from 'react';
import { useTournament } from 'context/TournamentContext';

import UserState from 'components/StatusFlow/UserState';
import TradeHistoryEmpty from 'components/StatusFlow/TradeHistoryEmpty';
import TradeHistoryMarginEmpty from 'components/StatusFlow/TradeHistoryMarginEmpty';
import Footer from 'components/ui/Footer';

import {
  RowBottom,
  ColLeft,
  Box,
  ColRight,
} from './styled';

const BottomSection = (props: { tournamentDetails: any; }) => {
  const { tournamentDetails } = useTournament();
  const rawData: any = tournamentDetails?.data;
  const attributes = rawData?.attributes ?? rawData?.data ?? rawData;
  const tournamentType = attributes?.trade_type;
  return (
    <RowBottom>
      <ColLeft>
        <Box>
          {(tournamentType === 'Margin') ? (
            <TradeHistoryMarginEmpty />
          ) :
            <TradeHistoryEmpty />
          }
        </Box>
      </ColLeft>
      <ColRight className="asideBox">
        <Box className="centerBox">
          <UserState tournamentDetails={tournamentDetails} />
        </Box>
        <Box className="centerBox">
          <Footer />
        </Box>
      </ColRight>
    </RowBottom>
  );
}
export default BottomSection;
